import { render, staticRenderFns } from "./Error_Page.vue?vue&type=template&id=478932ab&scoped=true&"
import script from "./Error_Page.vue?vue&type=script&lang=js&"
export * from "./Error_Page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478932ab",
  null
  
)

export default component.exports